import React, { useEffect, useState, useRef } from 'react';
import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useParams, Link, useHistory } from 'react-router-dom';
import axios from 'axios';
import swal from "sweetalert";
import ListItemIcon from '@mui/material/ListItemIcon';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import SwipeLeftIcon from '@mui/icons-material/SwipeLeft';
import { useDeadline } from '../../../contexts/DeadlineContext';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
const approve = (
  <Box
    component="span"
    sx={{ display: 'inline-block', mx: '6px', transform: 'scale(2)', pl: 5 }}>
    <FactCheckIcon />
  </Box>
);
const pending = (
  <Box
    component="span"
    sx={{ display: 'inline-block', mx: '6px', transform: 'scale(2)', pl: 5 }}
  >
    <SwipeLeftIcon />
  </Box>
);
const reject = (
  <Box
    component="span"
    sx={{ display: 'inline-block', mx: '6px', transform: 'scale(2)', pl: 5 }}
  >
    <SwipeLeftIcon />
  </Box>
);
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}))
const abstract_url = localStorage.getItem('abstract_url');
function Dashbord() {


  const [abstractArticle, setAbstractArticle] = React.useState([]);
  const eventid = localStorage.getItem('eventid');
  const role = localStorage.getItem('role');
  const eventName = localStorage.getItem('eventname');



  const history = useHistory();
  const svgRef = useRef(null);
  const { abstractHomeSetup } = useDeadline();
  const gradientBackground = '#05597D';// Example gradient background
  const isSmallScreen = useMediaQuery('(max-width:600px)');


  React.useEffect(() => {
    axios.get(`api/abstractApprovleArticle?id=${eventid}`).then(res => {
      if (res.status === 200) {
        const abstractArticleData = res.data.totalcount;
        setAbstractArticle(abstractArticleData)
      } else {
        swal('Error', "Check API Something Wrong", 'error');

      }
    })

  }, []);


  //const Hidden = 'hidden';


  function createData(
    ids,
    name,
    calories,
    fat,
    carbs,
    protein,

  ) {
    return { ids, name, calories, fat, carbs, protein };
  }
  const rows = [
    createData(1, 'Frozen yoghurt', "Frozen@test.com", 123456,),
  ]
  let backGroundButtonByEvent = "";
  if (eventid == 60) {
    backGroundButtonByEvent = '#1EB5B0'; // Assign the value conditionally
  }
  else {
    backGroundButtonByEvent = '#145348'; // Default background color
  }
  return (
    <Box sx={{ padding: isSmallScreen ? 2 : 4, width: '100%' }} >
      <Grid container spacing={isSmallScreen ? 2 : 4}>
        <Grid item xs={12} sm={12} md={12} lg={12} style={{ color: "purple", marginTop: isSmallScreen ? "20%" : "3%" }}>
          <Button sx={{
            float: 'right',
            marginTop: '0%',
            background: abstractHomeSetup.color_code_two || gradientBackground,
            ":hover": {
              color: "white"
            }
          }}
            color='success'
            size='small'
            variant='contained'

            onClick={() => history.goBack()} >
            Back
          </Button>
          <Item>
            <Typography variant={isSmallScreen ? "h5" : "h4"} gutterBottom>
              Abstract Dashboard
            </Typography>

          </Item>
        </Grid>


        <Grid item xs={12} style={{ color: "purple", marginTop: "2%" }}>
          <Item>

            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={12} lg={4}>
                <Card sx={{ minWidth: 275 }} >
                  <CardContent>
                    <Typography variant="h5" component="div">
                      Approved Abstract
                    </Typography>
                    <Typography variant="body2" variant="h2" color="success.main" key={1}>
                      {approve}. {abstractArticle.totalApprovearticle}
                    </Typography>
                  </CardContent>
                  <CardActions>
                    <Button size="small" component={Link}
                      to={`/admin/abstract/approve-article`}>Learn More</Button>
                  </CardActions>
                </Card>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={4}>
                <Card sx={{ minWidth: 275 }}>
                  <CardContent>
                    <Typography variant="h5" component="div">
                      Pending/Issue Abstract
                    </Typography>
                    <Typography variant="body2" variant="h2" color="secondary" key={2}>
                      {pending}. {abstractArticle.totalpending}
                    </Typography>
                  </CardContent>
                  <CardActions>
                    <Button size="small" component={Link} to={`/admin/abstract/pending-article`}>Learn More</Button>
                  </CardActions>
                </Card>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={4}>
                <Card sx={{ minWidth: 275 }}>
                  <CardContent>
                    <Typography variant="h5" component="div">
                      Rejected Abstract
                    </Typography>
                    <Typography variant="body2" variant="h2" color="error.main" key={3}>
                      {reject}. {abstractArticle.totalreject}
                    </Typography>
                  </CardContent>
                  <CardActions>
                    <Button size="small" component={Link} to={`/admin/abstract/reject-article`}>Learn More</Button>
                  </CardActions>
                </Card>
              </Grid>
            </Grid>
          </Item>
        </Grid>

        {role === "author" && (
          <Grid item xs={12} style={{ color: "purple", marginTop: "2%" }}>
            <Item>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={12} lg={4}>
                  <Card sx={{ minWidth: 275 }}>
                    <CardContent>
                      <Item>
                        <Button
                          variant="contained"
                          component={Link}
                          to={`/admin/abstract/add-approve-article`}
                          sx={{ backgroundColor: backGroundButtonByEvent }}
                        >
                          Submit Abstract
                        </Button>
                      </Item>
                    </CardContent>
                    <CardActions>
                      <Button
                        size="small"
                        component={Link}
                        to={`/admin/abstract/approve-article`}
                      >
                        Learn More
                      </Button>
                    </CardActions>
                  </Card>
                </Grid>
              </Grid>
            </Item>
          </Grid>
        )}
      </Grid>
      
    </Box>
  )
}

export default Dashbord
